import { mapGetters } from "vuex";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import updateFirebase from "@/data/cloud/firebase/mixins/updateFirebase.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";

export default {
  data() {
    return {
      valid: true
    };
  },
  // eslint-disable-next-line
  mixins: [
    dataSources,
    createFirebase,
    updateFirebase,
    storeFunctions,
    docLogFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getAdmin",
      "getAdminBasic",
      "getUserDID"
    ])
  },
  methods: {
    changeAdmin() {
      // u updated data that you want to send
      if (this.dbSource !== null) {
        this.btnSpinChangeAdmin = true;

        // DETAIL
        let temp = this.getAdmin; // this is object to be updated
        let tag = this.getAdmin.basic.tag;
        let did = this.getAdmin.basic.did;

        // BASIC
        if (this.getAdminBasic !== undefined && this.getAdminBasic !== null) {
          temp.basic = this.getAdminBasic;
        }

        console.log("");
        console.log(">>> Admin Detail Change <<<");
        console.log(this.getUserDID);
        console.log(did);
        console.log(tag);
        console.log(temp);
        console.log("");

        // UPDATE the USER STATS
        this.updateFirebaseDocumentUserStats("U1", did);
      }
    }
  }
};
